module.exports = __webpack_public_path__ + "static/media/frc-christmas-image-2.a143a070.jpg";